var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.editType,
          expression: "!editType"
        }
      ],
      staticClass: "title"
    },
    [
      _c("th", { attrs: { colspan: _vm.cardObject.column } }, [
        _c(
          "span",
          {
            style: {
              "pointer-events": _vm.cardObject.canEdit ? "auto" : "none"
            }
          },
          [
            _c("span", { staticClass: "title-text" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _vm.cardObject.canEdit
              ? _c("span", {
                  staticClass: "edit-icon",
                  on: { click: _vm.tableEdit }
                })
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2c29fe9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2c29fe9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/student-status-card/components/StatusCard/components/CCaption.vue
// module id = null
// module chunks = 